import { Injectable } from '@angular/core';
import { EmpresaVO } from '../shared/model';
import { Observable, BehaviorSubject } from 'rxjs';
import { EmpresaService } from './empresa.service';

@Injectable({
  providedIn: 'root'
})
export class CartaCreditoEmpresaService {

  private loadedRdaAutenticado: boolean = false;
  private empresaSubject$: BehaviorSubject<EmpresaVO[]> = new BehaviorSubject<EmpresaVO[]>(null);
  private empresasTrimestralSubject$: BehaviorSubject<EmpresaVO[]> = new BehaviorSubject<EmpresaVO[]>(null);
  private empresasAnualSubject$: BehaviorSubject<EmpresaVO[]> = new BehaviorSubject<EmpresaVO[]>(null);
  constructor(private readonly empresaService: EmpresaService) {
  }

  obterEmpresaRdaCartaCreditoCarregado(): Observable<EmpresaVO[]> {
    if (!this.loadedRdaAutenticado) {
      this.empresaService.obterEmpresaRdaCartaCredito().subscribe(empresa => {
          this.empresaSubject$.next(empresa)
          this.loadedRdaAutenticado = true;
        });
    }
    this.empresaSubject$.getValue();
    return this.empresaSubject$.asObservable();
  }

  obterEmpresaRdaCartaCredito(): EmpresaVO[] {
    if (!this.loadedRdaAutenticado) {
      this.empresaService.obterEmpresaRdaCartaCredito().subscribe(empresa => {
          if(!!empresa) {
            this.empresaSubject$.next(empresa)
            this.loadedRdaAutenticado = true;
          }
        });
    }
    return this.empresaSubject$.getValue();
  }

  atualizarEmpresasTrimestrais(empresas: EmpresaVO[]) {
    this.empresasTrimestralSubject$.next(empresas);
  }

  atualizarEmpresasAnual(empresas: EmpresaVO[]) {
    this.empresasAnualSubject$.next(empresas);
  }

  get empresasTrimestrais(): Observable<EmpresaVO[]> {
    return this.empresasTrimestralSubject$.asObservable();
  }

  get empresasAnual() : Observable<EmpresaVO[]> {
      return this.empresasAnualSubject$.asObservable();
  }

  getEmpresasAnuais(): EmpresaVO[] {
    return this.empresasAnualSubject$.getValue();
  }

}
